import { __read } from "tslib";
import * as NumberUtils from '../number';
export function coerce(value) {
    if (typeof value === 'number') {
        return [value, value];
    }
    return value;
}
export function create(x, y) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    return [x, y];
}
export function add(_a, value) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    var _c = __read(coerce(value), 2), x2 = _c[0], y2 = _c[1];
    return create(x + x2, y + y2);
}
export function divide(_a, value) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    var _c = __read(coerce(value), 2), x2 = _c[0], y2 = _c[1];
    return create(x / x2, y / y2);
}
export function isZero(_a) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    return x === 0 && y === 0;
}
export function hasZero(_a) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    return x === 0 || y === 0;
}
export function max(_a, _b) {
    var _c = __read(_a, 2), x1 = _c[0], y1 = _c[1];
    var _d = __read(_b, 2), x2 = _d[0], y2 = _d[1];
    return create(Math.max(x1, x2), Math.max(y1, y2));
}
export function min(_a, _b) {
    var _c = __read(_a, 2), x1 = _c[0], y1 = _c[1];
    var _d = __read(_b, 2), x2 = _d[0], y2 = _d[1];
    return create(Math.min(x1, x2), Math.min(y1, y2));
}
export function multiply(_a, value) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    var _c = __read(coerce(value), 2), x2 = _c[0], y2 = _c[1];
    return create(x * x2, y * y2);
}
export function negate(_a) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    return create(-x, -y);
}
export function subtract(_a, value) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    var _c = __read(coerce(value), 2), x2 = _c[0], y2 = _c[1];
    return create(x - x2, y - y2);
}
export function transform(_a, _b) {
    var _c = __read(_a, 2), x = _c[0], y = _c[1];
    var _d = __read(_b, 6), a = _d[0], b = _d[1], c = _d[2], d = _d[3], tx = _d[4], ty = _d[5];
    return create(x * a + y * c + tx, x * b + y * d + ty);
}
export function isCloseTo(_a, _b, precision) {
    var _c = __read(_a, 2), x1 = _c[0], y1 = _c[1];
    var _d = __read(_b, 2), x2 = _d[0], y2 = _d[1];
    return (NumberUtils.isCloseTo(x1, x2, precision) &&
        NumberUtils.isCloseTo(y1, y2, precision));
}
export function round(_a) {
    var _b = __read(_a, 2), x = _b[0], y = _b[1];
    return create(Math.round(x), Math.round(y));
}
